/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'

export async function getActiveCodes (deviceId) {
  // try {
  //   return (await docContentOf(doc(FireBaseStore, 'saas-active-products', deviceId))).codes
  // } catch (e) {
  //   return []
  // }
  try {
    return await hillo.get('https://cloud-v2.aaden.io/subscriptions/activeProductCodes/' + deviceId)
  } catch (e) {
    return []
  }
}
